import React from 'react';

import { flagStyles } from '../settings';

const SvgEQ = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-1512px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgEQ;
